import { Link, Stack, Typography } from '@mui/material';
import TelegramBg from '../../assets/icons/telegram-bg.webp';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useLocalization from '../../hooks/useLocalization';
import useSupportContacts from '../../hooks/useSupportContacts';

const BalanceContact = () => {
  const { t } = useLocalization();
  const supportContacts = useSupportContacts();

  const telegramUrl = supportContacts?.telegram?.url ?? 'https://t.me/slotparisupport';

  return (
    <Stack
      sx={{
        background: `url(${TelegramBg}) no-repeat`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        cursor: 'pointer',
        borderRadius: 2,
      }}
    >
      <Link
        href={telegramUrl}
        target='_blank'
        rel='noopener noreferrer'
        sx={{
          textDecoration: 'none',
          px: 2,
          py: 1,
        }}
      >
        <Typography
          variant='body1'
          component='h2'
          sx={{
            color: 'neutral.25',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {t('customerSupport')}
          <ArrowForwardIcon />
        </Typography>
        <Typography variant='body3' sx={{ color: 'neutral.200' }}>
          {t('acceptPaymentWithUs')}
        </Typography>
      </Link>
    </Stack>
  );
};

export default BalanceContact;
